import { cloneDeep } from "lodash-es";
import type z from "zod";
import { type ZodObject, type ZodRawShape } from "zod";

/**
 * Removes keys not belonging to the schema.
 */
export const cleanToSchema = <T extends ZodRawShape>(
  data: Record<string, unknown>,
  schema: ZodObject<T>,
): z.infer<ZodObject<T>> => {
  // Avoid deleting anything by reference.
  const _data = cloneDeep(data);

  // Test & clean if needed.
  const initResult = schema.safeParse(_data);

  if (initResult.success) {
    return initResult.data;
  } else {
    for (const issue of initResult.error.issues) {
      if (issue.code === "unrecognized_keys") {
        for (const key of issue.keys) {
          delete _data[key];
        }
      }
    }

    // Last check.
    const newResult = schema.safeParse(_data);

    if (newResult.error) throw newResult.error;

    return newResult.data;
  }
};
